<script lang="ts">
  import Capture from "./components/Capture.svelte";
  import Settings from "./components/Settings.svelte";
  import { hasApiKey } from "./lib/storage";

  let view: "capture" | "settings" = hasApiKey() ? "capture" : "settings";
</script>

<header class="top">
  <h1>wegli-quick</h1>
  <button type="button" on:click={() => (view = view === "settings" ? "capture" : "settings")}>
    {view === "settings" ? "Zurück" : "⚙"}
  </button>
</header>

<main>
  {#if view === "settings"}
    <Settings onClose={() => (view = "capture")} />
  {:else}
    <Capture />
  {/if}
</main>

<style>
  .top { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid var(--border); position: sticky; top: 0; background: var(--bg); z-index: 10; }
  .top h1 { margin: 0; font-size: 1rem; font-weight: 600; letter-spacing: 0.02em; }
  .top button { padding: 8px 14px; }
  main { padding-bottom: 40px; }
</style>
